import { makeEditorModal } from '../Modal';
import { Editor, TinyMCE } from 'tinymce';
import { createStdModal, editing, getData, insertToEditor, setWindowNode, toJsonHtml } from '../core/Utils';
import { receiveDrawitEvent, getFrame } from './DrawItEvents';
import { turnPictureToLabelingTask } from '../Inputs/Labeling';

declare let tinymce: TinyMCE;

interface DrawItData {
    identifier: string|number;
    path: string,
    oldIdentifier: string|number;
}

export function addDrawit(editor:Editor){
    initDrawIo();
    addDrawItButton(editor);
    insertCommandDrawit(editor);
    menuItemPopup(editor);
}

function initDrawIo(){
    createIframe();
    addListener();
}

function addListener(){
  window.addEventListener('message', receiveDrawitEvent)
}

function createIframe(){
    let iframe = '<div style="height: 100%; width: 100%;"><iframe id="drawio-iframe" src="" style="height: 100%; width: 100%;"></iframe>';
    iframe += '<input type="hidden" id="drawio-identifier" value="0"></div>';
    $(document.body).append(createStdModal('drawio-modal', iframe));
}

function addDrawItButton(editor: Editor){
    editor.ui.registry.addButton("drawit", {
        text: "",
        tooltip: 'DrawIt-Grafik erstellen',
        icon: "gallery",
        onAction: () => {
            createDrawitInstance(editor);
        }
    })
}


function showIframe(){
    const iframe = getFrame();
    iframe.src = 'https://embed.diagrams.net/?embed=1&analytics=0&gapi=0&db=0&od=0&proto=json&spin=1&lang=de&configure=1'
    document.getElementById("drawio-modal").style.display = "block";
}

function setIframeIdentifier(identifier:string|number){
    document.getElementById("drawio-identifier").value = identifier;
}

function createDrawitInstance(editor:Editor){
    showIframe();
    setIframeIdentifier(0);
}

function insertCommandDrawit(editor:Editor){
    editor.addCommand('insertGraphic', (ui, data) => {
        const html = insertDrawit(data);
        insertToEditor(html, tinymce.activeEditor);
    })
}

export function insertDrawit(data){
    const jsonData = {
        identifier: data.identifier,
    }
    const json = toJsonHtml(jsonData);
    const html = '<img id="graphic" src="' + data.path + '" class="mceNonEditable" width="auto" height="240px" data-json="' + json +'">'
    return html;
}

function menuItemPopup(editor:Editor){
    editor.ui.registry.addMenuItem('edit-drawit', {
        icon: 'edit-block',
        text: 'Bearbeiten',
        onAction: () => {
            const node = setWindowNode(editor);
            const data = getData(node);
            setIframeIdentifier(data.identifier);
            showIframe();
        }
    })

    editor.ui.registry.addMenuItem('add-img-to-label-task', turnPictureToLabelingTask())

    editor.ui.registry.addContextMenu('drawit', {
        update: (element:Element) => {
            return !editing(element, ['graphic']) ? '' : 'edit-drawit add-img-to-label-task';
        }
    })
}

